/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { isEmpty, sum, get } from 'lodash';
import AirQualityChart from './AirQualityChart';

const AirQuality = ({ environmentologyObservation, ...rest }) => {
  const airQualityChart = [];
  const labelData = [];
  const color = ['primary', 'secondary', 'info'];
  let count = 0;
  /* const series = get(
    environmentologyObservation,
    'carbon_nitogen_ozone.series',
    []
  ); */
  const series = ['CO', 'NO2', 'O3'];
  const data = get(
    environmentologyObservation,
    'carbon_nitogen_ozone.data',
    []
  );
  const xAxis = get(
    environmentologyObservation,
    'carbon_nitogen_ozone.date',
    []
  );
  series.forEach((label, index) => {
    labelData.push({
      label,
      color: color[index],
      value: sum(data[index])
    });
    airQualityChart.push({
      label,
      lineData: data[index]
    });
  });
  return (
    <Card {...rest}>
      <FalconCardHeader
        title={environmentologyObservation?.carbon_nitogen_ozone?.label}
        titleTag="h5"
        light
      />
      <Card.Body>
        <Row>
          <Col md="auto" className="mt-md-0">
            <Row className="flex-md-column justify-content-between h-md-100 ms-0">
              {labelData.map((stat, index) => (
                <Col
                  key={stat.label}
                  className={classNames('pt-3', {
                    'border-end border-md-end-0 border-md-bottom-chart empty-padding':
                      index !== 2,
                    'pt-md-4 empty-padding': index !== 0
                  })}
                >
                  <h6 className="fs--4 text-7">
                    <FontAwesomeIcon
                      icon="circle"
                      className={`text-${stat.color} me-2`}
                    />
                    {stat.label === 'CO' && <>CO</>}
                    {stat.label === 'NO2' && (
                      <>
                        NO<sub>2</sub>
                      </>
                    )}
                    {stat.label === 'O3' && (
                      <>
                        O<sub>3</sub>
                      </>
                    )}
                  </h6>
                  <h6 className="text-700 fs-0.5"></h6>
                </Col>
              ))}
            </Row>
          </Col>
          <Col md="auto" className="echart-active-users-report-container">
            <p className="units-text">
              (in mol/m<sup>2</sup>)
            </p>
            {!isEmpty(airQualityChart) && (
              <AirQualityChart data={airQualityChart} xAxis={xAxis} />
            )}
          </Col>
        </Row>
      </Card.Body>
      <Card.Footer className="bg-white py-2 card-footer-style">
        <h5 className="mb-0 infrence-info">
          {get(environmentologyObservation, 'carbon_nitogen_ozone.info', '')}
        </h5>
      </Card.Footer>
    </Card>
  );
};

export default AirQuality;
